import { Component, OnInit } from '@angular/core';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { PaymentService } from '../services/payment/payment.service';

@Component({
  selector: 'app-payment-statistics',
  templateUrl: './payment-statistics.component.html',
  styleUrls: ['./payment-statistics.component.css']
})
export class PaymentStatisticsComponent implements OnInit {

  customDateFormat = "";
  range: Range = { fromDate: new Date(), toDate: new Date() };
  options: NgxDrpOptions; locationId = null; billItems = [];
  presets: Array<PresetItem> = []; accountId = null; orgId = null;
  accounts: Account[] = [];

  datewisePayments = []; accountwisePayments = []; packagewisePayments = [];
  datewiseStatisticsSubscribe = null; packagewiseStatisticsSubscribe = null; accountwiseStatisticsSubscribe = null;
  filteredTime = {
    startDate: new Date(),
    endDate: new Date()
  }

  constructor(public accountService: AccountService, public foruscareService: ForuscareService, public paymentService: PaymentService) { }

  getAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  ngOnInit() {
    this.customDateFormat = this.foruscareService.getDateFormat().split(" ")[0];
    const today = new Date();
    const fromMin = new Date(today.getFullYear(), today.getMonth() - 2, 1);
    const fromMax = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const toMin = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const toMax = new Date(today.getFullYear(), today.getMonth() + 2, 0);

    this.setupPresets();
    this.options = {
      presets: this.presets,
      //format: 'mediumDate',
      format:this.foruscareService.getDateFormat().split(" ")[0],
      range: { fromDate: today, toDate: today },
      applyLabel: "Submit",
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
        hasBackdrop: false
      }
    };

    this.getAccounts();
    this.getStatistics();
  }

  getDatewisePayments() {
    if (this.datewiseStatisticsSubscribe != null) {
      this.datewiseStatisticsSubscribe.unsubscribe();
    }
    if (this.range.fromDate != null && this.range.toDate != null) {
      this.datewisePayments = [];
      this.datewiseStatisticsSubscribe = this.paymentService.getDatewisePayments(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate))
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.datewisePayments = response.data;
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
    else {
      this.foruscareService.showNotification("Please select valid date range", "danger");
    }
  }

  getPackagewisePayments() {
    if (this.packagewiseStatisticsSubscribe != null) {
      this.packagewiseStatisticsSubscribe.unsubscribe();
    }
    if (this.range.fromDate != null && this.range.toDate != null) {
      this.packagewiseStatisticsSubscribe = this.paymentService.getPaymentsByPackage(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate))
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              if (response.data.length > 0) {
                response.data = response.data.filter(function (info) {
                  return info.fieldValue > 0;
                });
              }
              this.packagewisePayments = response.data;
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
    else {
      this.foruscareService.showNotification("Please select valid date range", "danger");
    }
  }

  getAccountwisePayments() {
    if (this.accountwiseStatisticsSubscribe != null) {
      this.accountwiseStatisticsSubscribe.unsubscribe();
    }
    if (this.range.fromDate != null && this.range.toDate != null) {
      this.accountwiseStatisticsSubscribe = this.paymentService.getPaymentsByAccount(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate))
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              if (response.data.length > 0) {
                response.data = response.data.filter(function (info) {
                  return info.fieldValue > 0;
                });
              }
              this.accountwisePayments = response.data;
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
    else {
      this.foruscareService.showNotification("Please select valid date range", "danger");
    }
  }

  getStatistics() {
    this.getDatewisePayments();
    this.getAccountwisePayments();
    this.getPackagewisePayments();
    this.filteredTime = {
      startDate: this.range.fromDate,
      endDate: this.range.toDate
    }
  }

  // handler function that receives the updated date range object
  updateRange(range: Range) {
    this.range = range;
    this.getStatistics();
  }

  setupPresets() {

    const backDate = (numOfDays) => {
      const today = new Date();
      return new Date(today.setDate(today.getDate() - numOfDays));
    }

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7)
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: "Yesterday", range: { fromDate: yesterday, toDate: yesterday } },
      { presetLabel: "Last 7 Days", range: { fromDate: minus7, toDate: today } },
      { presetLabel: "Last 30 Days", range: { fromDate: minus30, toDate: today } },
      { presetLabel: "This Month", range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: "Last Month", range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ]
  }

}
